import { TraverseJoint } from './traverse-joint.js';

const GetAllMuscles = (joint) => {
    const muscles = new Set();
    const callback = (j) => {
        for (const b of j.bones) {
            for (const m of b.muscles) {
                muscles.add(m);
            }
        }
    };
    TraverseJoint(joint, [], callback);
    return Array.from(muscles);
};

export { GetAllMuscles };
//# sourceMappingURL=get-all-muscles.js.map
